import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, Input, message, Modal, notification, Upload } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText } from '@/utils/utils'
import { globalPrompt } from '@/components/message'
import { DictCodeEnmu } from '@/types/ScmDictEnums'
import { useSupplierDetailsMode } from './supplierDetailsModel'
import { ISupplierFormFields } from '../../supplierTypes'
import { debounce } from 'lodash'
import { supplierCategoryOption, supplierEnterpriseNatureOption, supplierTypeOption } from '@/types/supplierDs'

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertSupplier,
        updateSupplier,
        getSupplierDetailOne,
        resetEditCatch,
        resetAddCatch,
        saveLoading,
        setSaveLoading,
    } = useSupplierDetailsMode()

    const { selectedNavId, replaceNav, findNav } = useNavModel()

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!editFormVal.id && mode === 'edit') {
            getSupplierDetailOne(id)
        }
    }, [mode])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('2-1') && resetAddCatch()
            !findNav('2-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    const typeOnSelectChange = (val:string) => {
         saveCache({ type:val });
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: ISupplierFormFields) => {}

    //表单提交
    const onSubmit = () => {
        formRef.current
            ?.validateFields()
            .then((D) => {
                const { ...val } = D
                if (mode === 'edit') {
                    updateSupplier({ ...val, id })
                } else {
                    setSaveLoading(true)
                    insertSupplier(val)
                    .then((res) => {
                        resetEditCatch()
                        setSaveLoading(false)
                        // replaceNav('2-1', '2-2', {
                        //     id:res.id,
                        //     mode: 'edit',
                        // })
                        replaceNav(selectedNavId, '2')
                    })
                    .catch((err) => setSaveLoading(false))
                }
            })
            .catch((err) => {
                notification.open({
                    description: '',
                    message: getFormValidatorErrText(err),
                    duration: 20,
                    type: 'warning',
                    style: {
                        width: 900,
                        marginLeft: 300,
                    },
                    placement: 'topLeft',
                })
            })
    }

    const rightChildren = (
        <>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 600)}
            >
                {saveLoading ? '保存中' : '保存'}
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={() => replaceNav(selectedNavId, '2')}>
                返回
            </Button>
        </>
    )
    let newFormVal = mode === 'edit' ? editFormVal : addFormVal

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        rightChildren,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商编号',
                fieldName: 'code',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商名称',
                fieldName: 'name',
                rules: [{ required: true, message: '请输入供应商名称' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '简称',
                fieldName: 'abbreviation',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '类别',
                fieldName: 'category',
                options: supplierCategoryOption,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '开发人',
                fieldName: 'developer',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '开发部门',
                fieldName: 'developmentDepartment',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '企业性质',
                fieldName: 'enterpriseNature',
                options: supplierEnterpriseNatureOption,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '来源',
                fieldName: 'source',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '供应商类型',
                fieldName: 'type',
                options: supplierTypeOption,
                rules: [{ required: true, message: '请选择供应商类型' }],
                onSelectChange: typeOnSelectChange
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系地址',
                fieldName: 'address',
            },
        ],
    }

    const poFromConfig: IYhFormBox<ISupplierFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem],
    }

    return <YhFormBox {...poFromConfig} />
}
